<template>
    <div class="modal-content-detail">
        <div class="left">
            <div class="left-cell" v-for="(name,index) in gameScoreData.fromRefees" :key="index" :class="currentName==name?'cell-active':''" @click="handleChange(index)">{{name}}</div> 
        </div>
        <div class="right">
            <div class="header">
                <!-- 选择场次 -->
                <div class="title">   
                  <a-select :default-value="'ROUND'+currentRound" style="width: 140px" @change="handleChangeSelect" size="large">
                        <a-select-option :value="round" v-for="(round,index) in gameScoreData.rounds" :key="index">
                           ROUND     {{round}}
                        </a-select-option>
                   </a-select> 
                </div>
                <div class="back" @click="handleBackContentDetail">返回</div>
            </div>
            <div class="score">
                <div class="column-cell cell-red">{{gameScoreData.score}}</div>
                <StreeModalProgress :changeScore="item.result" :scoreName="item.name"  v-for="(item,index) in gameScoreData.list" :key="index"/>
            </div>
        </div>
    </div>
</template>

<script>
import StreeModalProgress from './StreeModalProgress.vue'
export default {
  name:'StreeModalContentDetail',
  props:['scoreDetail'],
  components: {
    StreeModalProgress,
  },
  data () {
    return {
      currentIndex:0,   
      currentRound:1,
      gameScoreData:{},
      currentName:'',
    }

  },
  mounted () {
    this.getGameScoreData()
    this.currentName=this.scoreDetail.fromRefee
  },
  watch: {
    scoreDetail () {
      this.getGameScoreData()
    }
  },
  methods: {
    handleChangeSelect (value){
      this.currentRound=value
      this.scoreDetail.round=value
      this.getGameScoreData()
    },
    handleChange (index) {
      this.currentIndex=index
      this.currentName=this.gameScoreData.fromRefees[index]
      this.getGameScoreData(this.currentName)
    },
    handleBackContentDetail (){
      //切换对战分数组件
      this.$emit('handleChangeDetail',false)
    },
    //获取对战分数详情
    getGameScoreData (currentName){
      let data={}
      data.fromRefee=currentName?currentName:this.scoreDetail.fromRefee
      data.pkId=this.scoreDetail.pkId
      data.round=this.scoreDetail.round
      data.scoreModle=this.scoreDetail.scoreModle
      this.$api.match.macthGameScore(data).then((res)=>{
        if(res.status==0){
          this.gameScoreData=res.data
        }else{
          this.$message.info('请求错误')
        }
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.modal-content-detail{
    width: 1100px;
    display: flex;
    justify-content: flex-start;
    .left{
        width: 150px;
        height: 420px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        padding-top: 5px;
        .left-cell{
            width: 100%;
            height: 100%;
            text-align: center;
            display: flex;
            flex: 1;
            justify-content: center;
            align-items: center;
            font-weight: bold;
            color: #333333;
            background-color: #EDEDED;
            cursor: pointer;
        }
        .cell-active{
            background-color: #ffffff;
        }
    }
    .right{
       width: 100%;
        height: 350px;
        position: relative;
        //分数头部
        .header{
            width: 220px;
            height: 50px;
            line-height: 50px;
            text-align: center;
            margin: 0 auto;
            background-color: #F6F6F6;
            color: #333333;
            font-weight: bold;
           
           .title{
                // .round-select{
                //     margin-right: 10px;
                //     height: 50px;
                //     line-height: 50px;
                //     background-color: #F6F6F6;
                //     border: none;
                //     appearance:none;
                //     width: 100px;
                //     outline:none;
                //     text-align: center;
                //     .round-option{
                //         width: 120px;
                //     }
                // }
                .icon{
                    color: #999999;
                    position: absolute;
                    top: 35%;
                    right: 30%;
                }
           }
            .back{
                position: absolute;
                color: #666666;
                font-size: 14px;
                right: 10px;
                top: -10px;
                cursor: pointer;
            }
           /deep/  .ant-select ,.ant-select-enabled ,.ant-select-lg{
                border: none;
            }
           /deep/  .ant-select-selection, .ant-select-selection--single{
                background-color: #F6F6F6;
                border: none;
            }
           /deep/ .ant-select-open  {
               border: none;
               background-color: #f6f6f6;
            }
           /deep/ .ant-select-focused  {
               border: none;
               background-color: #f6f6f6;
            }
        }
        //分数
        .score{
            padding: 15px 60px;
            width: 100%;
            height: 300px;
            .column-cell{
                    width: 120px;
                    height: 50px;
                    line-height: 50px;
                    text-align: center;
                    color: #ffffff;
                    font-weight: bold;
                    font-size: 16px;
                    margin-bottom: 10px;
            }
            .cell-blue{
                background-color: #2364B9;
            }
            .cell-red{
                background-color: #D53F48;
            }
            
        }
    }
 
}
</style>


// WEBPACK FOOTER //
// src/comm/components/modal/stree/StreeModalContentDetail.vue